var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GraphQLFormSearch',{attrs:{"formType":_vm.formType || `_REPORT_${_vm.report}`,"searchType":"report"}})
}
var staticRenderFns = []

export { render, staticRenderFns }